module.exports = __webpack_public_path__ + "static/media/orangeSmiley.44d7757e.png";